<script lang="ts">
	import Modal from './Modal.svelte';
	import Card, { Content, Actions } from '@smui/card';
	import Button, { Label } from '@smui/button';

	let dialog;

	export let showModal;
	export let title = 'Attenzione';
	export let content = "<p class='font-bold'>Sei sicuro di voler completare l'operazione?</p>";
	export let onConfirm = () => {};
	export let onCancel = () => dialog.close();

	function handleConfirm() {
		onConfirm();
		dialog.close();
	}
</script>

<Modal bind:showModal="{showModal}" bind:dialog="{dialog}">
	<div class="flex items-center justify-center">
		<Card class="w-full max-w-md bg-white rounded shadow-md">
			<h2 class="mx-6 mt-6 mb-2 text-3xl font-semibold text-gray-900">{title}</h2>
			<Content class="p-1">
				<div class="mx-6 leading-6 tracking-wide text-gray-600">{@html content}</div>
			</Content>
			<Actions>
				<Button style="background: lightgray" variant="raised" on:click="{onCancel}">
					<Label>No</Label>
				</Button>
				<Button variant="raised" on:click="{handleConfirm}">
					<Label>Si</Label>
				</Button>
			</Actions>
		</Card>
	</div>
</Modal>
